/**
 * Carrousel des cuvées préférées des vignerons.
 * Croise deux sources :
 * - le Google Sheet des portraits (colonnes Prénom + "Cuvée préférée")
 * - quiz-vigneron-data.json (les 10 cuvées, avec couleur et lien produit)
 *
 * La colonne "Cuvée préférée" est du texte libre ("Coteaux - Blanc & Rouge",
 * "Les Coteaux" sans couleur précisée, etc.) — ce script la rapproche des
 * vraies cuvées par mots-clés plutôt que par correspondance exacte.
 */
(function () {
  var FAMILIES = [
    { keys: ["chant des roches"], colors: { blanc: "chant-des-roches-blanc-2025", rose: "chant-des-roches-rose-2025", rosé: "chant-des-roches-rose-2025" } },
    { keys: ["petite folie"], colors: { rose: "petite-folie-rose-2025", rosé: "petite-folie-rose-2025", any: "petite-folie-rose-2025" } },
    { keys: ["tuiliere", "tuilière"], colors: { any: "domaine-tuiliere-rose-2025" } },
    { keys: ["sauvage"], colors: { any: "sauvage-rose-2025" } },
    { keys: ["prestige"], colors: { any: "prestige-rouge-2024" } },
    { keys: ["schiste"], colors: { any: "de-schiste-et-dazur-rouge-2023" } },
    { keys: ["coteaux"], colors: { blanc: "coteaux-blanc-2025", rose: "coteaux-rose-2025", rosé: "coteaux-rose-2025", rouge: "coteaux-rouge-2024" } }
  ];

  function stripAccents(str) {
    return (str || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }

  function matchWineIds(text) {
    var norm = stripAccents(text).toLowerCase();
    var mentionedColors = [];
    if (/\bblanc/.test(norm)) mentionedColors.push("blanc");
    if (/\bros/.test(norm)) mentionedColors.push("rose");
    if (/\brouge/.test(norm)) mentionedColors.push("rouge");

    for (var i = 0; i < FAMILIES.length; i++) {
      var fam = FAMILIES[i];
      var found = fam.keys.some(function (k) { return norm.indexOf(stripAccents(k)) > -1; });
      if (!found) continue;

      if (fam.colors.any) return [fam.colors.any];

      if (mentionedColors.length) {
        var ids = mentionedColors
          .map(function (c) { return fam.colors[c]; })
          .filter(Boolean);
        if (ids.length) return ids;
      }
      // pas de couleur précisée : on inclut toutes les variantes de la famille
      var allIds = Object.keys(fam.colors)
        .filter(function (k) { return k !== "any"; })
        .map(function (k) { return fam.colors[k]; });
      return allIds.filter(function (id, idx) { return allIds.indexOf(id) === idx; });
    }
    return [];
  }

  function init(root) {
    var sheetUrl = root.dataset.sheetUrl;
    var dataUrl = root.dataset.dataUrl;
    if (!sheetUrl || !dataUrl || typeof Papa === "undefined") return;

    Promise.all([
      new Promise(function (resolve) {
        Papa.parse(sheetUrl, {
          download: true,
          header: true,
          skipEmptyLines: true,
          transformHeader: function (h) { return h.replace(/^\uFEFF/, "").trim(); },
          transform: function (v) { return typeof v === "string" ? v.trim() : v; },
          complete: function (results) { resolve(results.data); }
        });
      }),
      fetch(dataUrl).then(function (r) { return r.json(); })
    ]).then(function (values) {
      var rows = values[0];
      var vins = values[1].vins || [];
      buildCarousel(root, rows, vins);
    });
  }

  function buildCarousel(root, rows, vins) {
    var fansByWineId = {};

    rows.forEach(function (r) {
      var name = r["Prénom"];
      var pref = r["Cuvée préférée"];
      if (!name || !pref) return;
      matchWineIds(pref).forEach(function (id) {
        if (!fansByWineId[id]) fansByWineId[id] = [];
        if (fansByWineId[id].indexOf(name) === -1) fansByWineId[id].push(name);
      });
    });

    var lookup = window.cpProductLookup || {};
    var cardsHtml = Object.keys(fansByWineId)
      .map(function (id) {
        var vin = vins.find(function (v) { return v.id === id; });
        if (!vin) return "";
        var product = lookup[vin.shopify_title] || {};
        var fans = fansByWineId[id];
        var fansLabel;
        if (fans.length === 1) {
          fansLabel = "La préférée de " + fans[0];
        } else if (fans.length === 2) {
          fansLabel = "La préférée de " + fans[0] + " et " + fans[1];
        } else {
          fansLabel = "La préférée de " + fans[0] + " + " + (fans.length - 1) + " autres";
        }
        var macarons = '<span class="cp-macaron">' + fansLabel + "</span>";
        var image = product.image
          ? '<img src="' + product.image + '" alt="' + vin.nom + '" loading="lazy">'
          : "";
        return (
          '<a class="cp-card" href="' + (product.url || "#") + '">' +
          '<div class="cp-macarons">' + macarons + "</div>" +
          '<div class="cp-card-image">' + image + "</div>" +
          '<div class="cp-card-body">' +
          '<p class="cp-card-name">' + vin.nom + "</p>" +
          (vin.appellation ? '<p class="cp-card-appellation">' + vin.appellation + "</p>" : "") +
          (product.price ? '<p class="cp-card-price">' + product.price + "</p>" : "") +
          "</div></a>"
        );
      })
      .join("");

    var track = root.querySelector("[data-cp-track]");
    track.innerHTML = cardsHtml || '<p style="text-align:center;width:100%;">Pas encore de cuvées préférées renseignées.</p>';

    var step = function () {
      return (track.querySelector(".cp-card") || {}).offsetWidth + 20 || 240;
    };
    var prev = root.querySelector("[data-cp-prev]");
    var next = root.querySelector("[data-cp-next]");
    if (prev) prev.addEventListener("click", function () { track.scrollBy({ left: -step(), behavior: "smooth" }); });
    if (next) next.addEventListener("click", function () { track.scrollBy({ left: step(), behavior: "smooth" }); });
  }

  document.querySelectorAll("[data-cuvees-preferees]").forEach(init);
})();